import React from 'react'
import {Switch} from 'react-router'
import {withRouter} from 'react-router-dom'
import TransitionGroup from 'react-transition-group/TransitionGroup'
import { CSSTransition } from 'react-transition-group'
import './animatedRouterSwitch.css'

const AnimatedRouterSwitch = withRouter(({ location, children, shouldTransitionFunc }) => {
  const shouldTransition = shouldTransitionFunc(location)
  return (
    <TransitionGroup className="animated-switch">
      <CSSTransition classNames="fade" timeout={300} key={shouldTransition}>
        <Switch location={location}>
          {children}
        </Switch>
      </CSSTransition>
    </TransitionGroup>
  )
})

export default AnimatedRouterSwitch



// WEBPACK FOOTER //
// ./src/core/components/animated-router-switch/AnimatedRouterSwitch.js